import React from 'react';
import { Badge, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CampaignIcon from '@mui/icons-material/Campaign';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export type MobileTab = 'browse' | 'upload' | 'cart' | 'listningar' | 'inhouse' | 'more';

export default function MobileFooterNav(props: {
  value: MobileTab;
  onChange: (value: MobileTab) => void;
  cartCount: number;
  canUpload: boolean;
  canViewListningar: boolean;
  canViewInhouse: boolean;
}) {
  const { value, onChange, cartCount, canUpload, canViewListningar, canViewInhouse } = props;

  return (
    <Paper elevation={6} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_, next) => onChange(next as MobileTab)}
      >
        <BottomNavigationAction label="Browse" value="browse" icon={<GridViewIcon />} />
        {canUpload && (
          <BottomNavigationAction label="Ladda upp" value="upload" icon={<FileUploadIcon />} />
        )}
        <BottomNavigationAction
          label="Varukorg"
          value="cart"
          icon={
            <Badge color="error" badgeContent={cartCount} showZero={false}>
              <ShoppingCartIcon />
            </Badge>
          }
        />
        {canViewListningar && (
          <BottomNavigationAction label="Listningar" value="listningar" icon={<CampaignIcon />} />
        )}
        {canViewInhouse && (
          <BottomNavigationAction label="Inhouse" value="inhouse" icon={<CampaignIcon />} />
        )}
        <BottomNavigationAction label="Mer" value="more" icon={<MoreHorizIcon />} />
      </BottomNavigation>
    </Paper>
  );
}

